import { css } from 'lit';
export const styles = css `
:host(:focus){outline:0}:host([variant=subtle-divider]) ::slotted(hds-togglelist-item[id^=hds-list-item-]){box-shadow:none}.-hds-togglelist .-hds-list-wrapper{background:none;border:0;filter:none;max-width:none;padding:var(--hds-spacing-0)}
`;
//# sourceMappingURL=hds-togglelist.css.js.map